import ActionsForm from '@/shared/mixins/actionsForm'
import AccrediteddateRepository from '@/shared/http/repositories/realestate/accrediteddate'
import StateRepository from '@/shared/http/repositories/realestate/state'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'Searchaccredited',
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },
  data () {
    return {
      title: 'Buscar Credenciada',
      SearchItems: {
        cidadeObj: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        imobiliariaObj: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        Imobiliaria: '',
        estadoId: '',
        situacao: '',
        Cidade: '',
        cidadeId: '',
        credenciadaId: '',
        DataCadastroInicio: '',
        DataCadastroFim: ''
      },
      state: [],
      Imoempreend: [],
      situacaoCredenciada: [
        {value: null, text: 'Todos os status'},
        {value: 0, text: 'Ativo'},
        {value: 1, text: 'Inativo'}
      ]
    }
  },
  mounted () {
    this.onLoad()
    this.getState()
  },
  methods: {
    onLoad () {
      AccrediteddateRepository.GetAll()
        .then(Response => {
          this.Imoempreend = Response.data.data
        })
        .catch(() => {})
    },
    getState () {
      StateRepository.GetAll()
        .then(Response => {
          this.state = Response.data.data
        })
        .catch(() => {})
    },
    Clear () {
      localStoreHelper.gestao.credenciada(null)
      this.$refs.CidadeTypeahead.clear()
      this.$refs.ImobliariaTypeahead.clear()
      Object.keys(this.SearchItems).forEach(prop => {
        if (prop === 'cidadeObj') {
          this.SearchItems[prop].value = null
        } else if (prop === 'imobiliariaObj') {
          this.SearchItems[prop].value = null
        } else {
          this.SearchItems[prop] = ''
        }
      })
      this.$emit('SearchItems', this.SearchItems, false)
    },
    Search () {
      var today = new Date()
      if (this.SearchItems.DataCadastroInicio !== '' && this.SearchItems.DataCadastroFim === '') {
        this.SearchItems.DataCadastroFim = today
      }
      this.SearchItems.cidadeId = this.SearchItems.cidadeObj == null ? undefined : this.SearchItems.cidadeObj.value
      this.SearchItems.imobiliariaId = this.SearchItems.imobiliariaObj == null ? undefined : this.SearchItems.imobiliariaObj.value
      this.$emit('SearchItems', this.SearchItems, true)
      localStoreHelper.gestao.credenciada({cidadeId: this.SearchItems.cidadeObj.value, imobiliariaId: this.SearchItems.imobiliariaObj.value, estadoId: this.SearchItems.estadoId, situacao: this.SearchItems.situacao, DataCadastroInicio: this.SearchItems.DataCadastroInicio, DataCadastroFim: this.SearchItems.DataCadastroFim})
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/searchaccredited/searchaccredited.js